import clsx from "clsx";
import { useEffect, useState } from "react";

import { isRtl } from "~/helpers/helpers.ts";

import { Icon } from "../../../assets/icons/Icon";
import Button from "../../mantine/button/Button";
import Spinner from "../../ui/spinner/Spinner";
import styles from "./Interlinks.module.scss";

interface PageDetail {
  id?: number;
  inner_text?: string;
  suggestion?: string;
  final?: string;
  active?: boolean;
  approved?: boolean;
  path?: string;
  appearances?: number;
  page_id?: number;
  lang?: string;
}

interface InterlinksItemProps {
  item: PageDetail;
  index: number;
  isFirstItem: boolean;
  isWidgetActionLoading: boolean;
  lastClickedId: number | null;
  onApprove: (detail: PageDetail, event: React.MouseEvent) => void;
  onEdit: (detail: PageDetail, event: React.MouseEvent) => void;
}

const InterlinksItem: React.FC<InterlinksItemProps> = ({
  item,
  index,
  isFirstItem,
  isWidgetActionLoading,
  lastClickedId,
  onApprove,
  onEdit,
}) => {
  const [isOpen, setIsOpen] = useState(isFirstItem);

  const toggleContent = () => {
    setIsOpen(!isOpen);
  };

  const isCurrentItemLoading =
    isWidgetActionLoading && lastClickedId === item.id;

  useEffect(() => {
    if (isFirstItem) {
      setIsOpen(true);
    }
  }, [isFirstItem]);

  return (
    // @ts-expect-error TS2339 non-existing className
    <div className={styles.pageItem} key={index}>
      <div
        // @ts-expect-error TS2339 non-existing className
        className={`${styles.currentItem} ${isOpen ? styles.open : styles.closed}`}
      >
        <div
          // @ts-expect-error TS2339 non-existing className
          className={`${styles.currentItemHeader} ${isOpen ? styles.open : styles.closed}`}
          onClick={toggleContent}
        >
          <Icon
            iconName={isOpen ? "IconDown" : "ArrowRightIcon"}
            width="1rem"
            height="1rem"
          />

          <div className={styles.currentItemHeaderTitle}>
            <div className={styles.currentItemHeaderTitleText}>
              {item.inner_text}
            </div>
            <div className={styles.currentItemHeaderIcons}>
              <Button
                variant="nohoverWithPadding"
                onClick={(event) => onEdit(item, event)}
              >
                <Icon iconName="EditIcon" width="1rem" height="1rem" />
              </Button>

              <Button
                variant="nohoverWithPadding"
                onClick={(event) => onApprove(item, event)}
              >
                {isCurrentItemLoading ? (
                  <Spinner size="1rem" />
                ) : (
                  <Icon
                    iconName={
                      item?.active ? "GreenCheckmarkIcon" : "CloseIconCircled"
                    }
                    width="1rem"
                    height="1rem"
                  />
                )}
              </Button>
            </div>
          </div>
        </div>

        {isOpen && (
          <div className={styles.currentItemContent}>
            <div className={styles.currentItemContentDescription}>
              <div className={styles.currentItemContentTitle}>Suggestion</div>
              <div
                className={clsx(styles.currentItemContentText, {
                  ["rtl"]: isRtl(item.lang),
                })}
                lang={item.lang || undefined}
              >
                {item.final || item.suggestion || ""}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InterlinksItem;
